<template>
  <div :classList="'confirmation-modal'" class="bet-slip-bet-place-content bet-slip-fixed-content">
    <div
      class="content-title"
      :class="{
        success: isSuccess,
        error: !isSuccess,
      }"
    >
      {{ isSuccess > 0 ? $t('BetSlip.Place Bet Success') : $t('BetSlip.Place Bet Success No Bet') }}
      <img
        class="modal__icon"
        v-if="isSuccess"
        :src="$isElectron ? '/assets/images/circle_check.png' : '/assets/images/confirm_active.svg'"
      />
    </div>
    <div class="confirmation-wrapper">
      <div class="rows-wrapper">
        <bet-slip-confirmation
          :bet-response-source="placesResponse"
          :showSuccess="true"
          :placed="isSuccess"
        ></bet-slip-confirmation>

        <!--
        <bet-slip-confirmation
          v-if="!isSuccess"
          :bet-response-source="errorBets"
          :showSuccess="false"
          :placed="false"
        ></bet-slip-confirmation>
        -->
      </div>
      <div class="bet-slip-button-area pb-1 pl-1 pr-2">
        <div>
          <a
            v-if="isSuccess"
            href
            style="height: 36px; padding: 0"
            class="btn btn-large mt-3 btn-orange d-flex justify-content-center align-items-center"
            @click.prevent="startNewBet()"
            :class="{ disabled: disableButtons }"
            >{{ $t('BetSlip.StartNewBet') }}</a
          >

          <a
            v-else
            href
            class="btn btn-large mt-3 btn-orange d-flex justify-content-center align-items-center pt-1"
            @click.prevent="setCurrentState('BET_PREPARE')"
            >{{ $t('DepositView.ACH.Step2.ButtonContinue') }}</a
          >
        </div>
      </div>
    </div>
  </div>
  <!--
  <modal :closeable="true" :type="'danger'" @close="onCloseErrorModal" v-else>
    <div class="d-flex justify-content-center align-items-center">
      <template v-if="error.message_code === 'INVALIDGAMESTATUS'">
        <span class="text-center" style="font-size: 1.1rem;">
          {{ $t('BetSlip.Errors.' + error.message_code, [error.message_parameters]) }}</span
        >
      </template>

      <span v-else class="text-center" style="font-size: 1.1rem;">
        {{ $t('BetSlip.Errors.' + error.message_code) }}</span
      >
    </div>
  </modal>
  -->
</template>

<script>
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';
import BetSlipConfirmation from './BetSlipConfirmation';
import { ExternalWagerLoginTypes } from '@/utils/enums';
import ConfirmationModal from '@/components/shared/BonusModal';
import snq from 'snq';
import { flatten } from 'lodash/array';
import moment from 'moment';
export default {
  components: {
    BetSlipConfirmation,
    ConfirmationModal,
  },
  computed: {
    ...mapGetters('player', ['currencySymbol']),
    ...mapState({
      currentState: (state) => state.betSlip.currentState,
      betPlaceResponse: (state) => state.betSlip.betPlaceResponse,
      betPlaceStatus: (state) => state.betSlip.betPlaceStatus,
      loginType: (state) => state.player.loginType,
    }),
    placesResponse() {
      if (this.betPlaceResponse.places) {
        return this.betPlaceResponse.places;
      }
      return this.betPlaceResponse;
    },
    isDepositUser() {
      return this.loginType === ExternalWagerLoginTypes.DepositTicket;
    },

    ticketIds() {
      const ids = [];
      try {
        const bets = snq(
          () =>
            JSON.parse(
              JSON.stringify(this.placesResponse),
            ),
          [],
        );
        bets.forEach((bet) => {
          ids.push(bets.TicketNumber);
        });
      } catch (e) {
        console.log({ e });
      }

      return flatten(ids).filter(Boolean);
    },

    betDate() {
      return moment().date();
    },

    error() {
      return snq(() => !this.placesResponse.IsSuccess);
    },
    printing() {
      return this.$store.state.betSlip.printing;
    },
    disableButtons() {
      if (!this.$isElectron) {
        return false;
      }
      return this.error ? false : this.$store.state.betSlip.printing;
    },
    successCounts() {
      return this.successBets.length;
    },
    isSuccess() {
      return this.successCounts > 0;
    },
    successBets() {
      return this.placesResponse.filter((bet) => bet.IsSuccess);
    },
    errorBets() {
      return this.placesResponse.filter((bet) => !bet.IsSuccess);
    },
  },
  methods: {
    ...mapActions({
      clearBetSlip: 'betSlip/clearBetSlip',
      placeBet: 'betSlip/placeBet',
      logoutAndRefresh: 'player/logoutAndRefresh',
      getBetTabs: 'betSlip/getBetTabs',
      getNewBetOptions: 'betSlip/getNewBetOptions',
    }),
    ...mapMutations({
      setCurrentState: 'betSlip/setCurrentState',
      resetBetSlip: 'betSlip/resetBetSlip',
    }),
    hasPlaceError() {
      return this.placesResponse.filter((row) => !row.IsSuccess).length > 0;
    },
    tryLogout() {
      if (this.loginType === ExternalWagerLoginTypes.DepositTicket) {
        this.logoutAndRefresh(this.$isElectron);
      }
    },
    startNewBet() {
      this.resetBetSlip(true);
      this.getBetTabs();
      this.getNewBetOptions();
    },
    onClose() {
      if (this.hasPlaceError()) {
        this.setCurrentState('BET_PREPARE');
      } else {
        this.resetBetSlip(true);
        this.getBetTabs();
        this.getNewBetOptions();
      }
    },
    onCloseErrorModal() {
      this.setCurrentState(null);
      if (this.error.message_code === 'WSP_LINE_NO_LONGER_AVAILABLE') {
        window.location.reload();
      }
    },
  },
};
</script>
<style scoped>
.modal__icon {
  width: 90px;
}
</style>
